import businessClient from 'src/services/clients/business'
import {
  IBusyMode,
  IMenuEntityAvailability,
  IResponse,
  IItemEntityAvailability,
  IModifierEntityAvailability,
  IEntityAvailability,
  IBusyModeFilter,
  IEntityAvailabilityFilter,
  IBusyModeUpdatePayload,
  IEntityAvailabilityUpdatePayload,
} from 'src/common/interfaces'
import { GenericAbortSignal } from 'axios'

type BusyModeResponse = IResponse<{ busy_mode_data: IBusyMode }>
type BusyModeUpsertResponse = IResponse<{ upsert: IBusyMode[] }>

type IMenuAvailabilityResponse = IResponse<{ list: IMenuEntityAvailability[]; count: number }>
type IItemAvailabilityResponse = IResponse<{ list: IItemEntityAvailability[]; count: number }>
type IModifierAvailabilityResponse = IResponse<{ list: IModifierEntityAvailability[]; count: number }>
type IEntityAvailabilityResponse = IMenuAvailabilityResponse | IItemAvailabilityResponse | IModifierAvailabilityResponse
type IEntityAvailabilityUpsertResponse = IResponse<{ upsert: IEntityAvailability[] }>

export const menuAvailability = {
  getBusyModeStatus(filter: IBusyModeFilter, signal: GenericAbortSignal | undefined): Promise<BusyModeResponse> {
    return businessClient().post('/availability/busy-mode/portal/get', { filter }, { signal })
  },

  setBusyModeStatus(
    data: IBusyModeUpdatePayload,
    signal: GenericAbortSignal | undefined,
  ): Promise<BusyModeUpsertResponse> {
    return businessClient().post('/availability/busy-mode/portal/set', { data }, { signal })
  },

  getEntityAvailability(
    filter: IEntityAvailabilityFilter,
    signal: GenericAbortSignal | undefined,
  ): Promise<IEntityAvailabilityResponse> {
    return businessClient().post('/availability/entity/portal/list', { filter }, { signal })
  },

  setEntityAvailability(
    data: IEntityAvailabilityUpdatePayload,
    signal: GenericAbortSignal | undefined,
  ): Promise<IEntityAvailabilityUpsertResponse> {
    return businessClient().post('/availability/entity/portal/set', { data }, { signal })
  },
}
